import axios from "axios";

export const http = axios.create({
    baseURL: process.env.VUE_APP_BACK_END
})

export const httpCustom = axios.create({
    baseURL: process.env.VUE_APP_BACK_END
})

export const httpAuth = axios.create({
    baseURL: process.env.VUE_APP_URL_AUTH
})
